module.exports = __webpack_public_path__ + "static/media/relation2.4cb66095.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/relation2.jpg
// module id = 458
// module chunks = 0